<template>
    <v-app-bar
            absolutes
            dark
            color="black"
            class="main-header"
            height="65"
    >
        <v-container>
            <v-layout align-center>
                <v-flex xs12 class="text-center">
                    <img :src="require('../assets/logo.png')" class="custom-logo" alt="cargocard" itemprop="logo">
                </v-flex>
            </v-layout>
        </v-container>
    </v-app-bar>
</template>

<script>
    export default {
        name: 'Header',
        data: () => {
            return {
                menu: false,
            }
        },
        methods: {
            scrollTo: function(target) {
                this.$vuetify.goTo(target, this.options)
            }
        }
    }
</script>

<style lang="scss">
    .main-header {
        .menu-item {
            a {
                padding: 0 1em;
                font-size: 16px;
                color: #FFFFFF !important;
                text-decoration: none;
                text-transform: uppercase;
                &:hover {
                    opacity: 0.7;
                }
            }
        }
        .custom-logo {
           margin-top: 5px;
        }
        .menu-icon-link {
            border-radius: 7px !important;
        }
        .v-list, .v-menu__content {
            border-radius: 0 !important;
        }
        .v-menu__content {
            max-width: 100% !important;
            width: 100%;
            left: 0 !important;
        }
        .v-chip {
            .v-chip__content {
                cursor: pointer !important;
            }
        }
    }
</style>